import { X, Plus, Camera } from "lucide-react";
import { Button } from "@/components/ui/button";

// Reviews/deletes photos on the Scanner page — a normalized mix of not-yet-uploaded local shots
// (App.jsx photoFiles, kind: "local") and files already saved on the server for the document
// currently being edited (App.jsx attachedFiles, kind: "remote"). Each entry is { src, name, kind,
// id | localIndex } — see App.jsx's allPhotos — so this component doesn't need to know how to
// delete either kind, just report which item was clicked via onDelete.
export default function LocalPhotosModal({ files, onDelete, onAddClick, onCameraClick, onPhotoClick, onClose }) {
  return (
    <div
      className="fixed inset-0 bg-black/60 z-[300] flex items-center justify-center p-4"
      onMouseDown={e => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full overflow-hidden flex flex-col" style={{ maxWidth: 720, maxHeight: "85vh" }}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100 flex-shrink-0">
          <span className="text-base font-bold text-slate-900">Фото ({files.length})</span>
          <div className="flex items-center gap-2">
            <Button size="sm" variant="ghost" className="gap-1.5" onClick={onCameraClick}>
              <Camera className="h-3.5 w-3.5" />
              Снять камерой
            </Button>
            <Button size="sm" className="gap-1.5" onClick={onAddClick}>
              <Plus className="h-3.5 w-3.5" />
              Добавить
            </Button>
            <Button variant="ghost" size="icon" className="h-7 w-7" onClick={onClose}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
        <div className="px-5 py-4 overflow-y-auto">
          {files.length === 0 ? (
            <div className="flex flex-col items-center justify-center gap-2 py-12 text-slate-400">
              <Camera className="h-8 w-8" />
              <span className="text-sm">Пока нет фото — нажмите «Добавить»</span>
            </div>
          ) : (
            <div className="grid gap-3" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))" }}>
              {files.map((f, i) => (
                <div key={f.kind === "remote" ? f.id : `local-${f.localIndex}`} className="relative group">
                  <button onClick={() => onPhotoClick(i)} className="block w-full">
                    <img src={f.src} alt={f.name || "Фото"} className="w-full aspect-square rounded-lg border border-slate-200 object-cover" />
                  </button>
                  <button
                    onClick={() => onDelete(f)}
                    className="absolute top-1.5 right-1.5 h-6 w-6 flex items-center justify-center rounded-full bg-white/90 border border-slate-200 text-slate-400 hover:text-red-600 hover:border-red-200 opacity-0 group-hover:opacity-100 transition-opacity"
                    title="Удалить фото"
                  >
                    <X className="h-3.5 w-3.5" />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
